/**
 * Rutas Generales
 * Rutas básicas protegidas (dashboard, perfil)
 */
import { Route } from 'react-router-dom'
import ProtectedRoute from '../components/ProtectedRoute.jsx'
import Dashboard from '../pages/Dashboard.jsx'
import Profile from '../pages/Profile.jsx'
import AccesoDenegado from '../pages/general/AccesoDenegado.jsx'

export const generalRoutes = [
  <Route 
    key="dashboard" 
    path="/dashboard" 
    element={
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="profile" 
    path="/profile" 
    element={
      <ProtectedRoute>
        <Profile />
      </ProtectedRoute>
    } 
  />,
  <Route
    key="acceso-denegado"
    path="/acceso-denegado"
    element={
      <ProtectedRoute>
        <AccesoDenegado />
      </ProtectedRoute>
    }
  />,
]

